import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import { style } from "@mui/system";
import FilterName from "../../../components/Atoms/FilterName";
import styles from "./barGraph.module.scss";
import { Flex } from "antd";

const Flags = ({
  series,
  categories,
  height,
  filter1Name,
  filter2Name,
  setFilter1Name,
  setFilter2Name,
  comparisonMode,
  setSelectedInternalFilters,
}) => {
  // Labels for the pie chart
  const [flags, setFlags] = useState([]);
  const [flagSvg, setFlagSvg] = useState([]);
  const [results, setResults] = useState([]);

  //----------------------------------------------
  useEffect(() => {
    // results && results.length && console.log(results);
  }, [results]);
  //----------------------------------------------
  useEffect(() => {
    // console.log(flagSvg);
    // console.log(flagSvg);

    let arr1 = [...flagSvg];
    let arr = [];

    for (let i = 0; i < arr1.length; i++) {
      arr.push({
        CountryName: arr1[i].name,
        CountryCount:
          series &&
          series.length &&
          [...series][0].data[[...categories].indexOf(arr1[i].name)]
            ? [...series][0].data[[...categories].indexOf(arr1[i].name)]
            : 0,
        CountryFlag: arr1[i].flag,
      });
    }
    setResults(arr.sort((a, b) => b.CountryCount - a.CountryCount));
  }, [flagSvg]);

  //-------------------------------------------------------
  const fetchAllFlags = async () => {
    try {
      const response = await axios.get("https://restcountries.com/v3.1/all");
      const flagData = response.data.map((country) => ({
        name: country.name.common,
        flag: country.flags.svg,
      }));
      setFlagSvg(flagData);
    } catch (err) {
      setFlagSvg([]);
    }
  };

  //------------------------

  useEffect(() => {
    let arr1 = series && series.length ? [...series][0].data : [];
    let arr2 = [...categories];
    let arr = [];

    for (let i = 0; i < arr1.length; i++) {
      const element = arr1[i];
      arr.push({
        CountryName: arr2[i],
        CountryCount: element,
      });
    }
    setFlags(arr);

    fetchAllFlags();

    // setResults([...series].sort((a, b) => b - a));
  }, [series]);

  const [Filter1, setFilter1] = useState(filter1Name && filter1Name);
  const [Filter2, setFilter2] = useState(filter2Name && filter2Name);

  useEffect(() => {
    setFilter1(filter1Name);
  }, [filter1Name]);

  useEffect(() => {
    setFilter2(filter2Name);
  }, [filter2Name]);
  //------------------------------------------------------------------
  return (
    <div
      className="row"
      style={{ height: height, paddingTop: "10%", display: "Flex", gap: "5%" }}
    >
      {comparisonMode && (
        <div className={`${styles.comparisonBtnsContainer} row `}>
          <FilterName
            filter={Filter1 && Filter1}
            filterType="normal"
            setFilter1Name={setFilter1}
            setFilter2Name={setFilter2}
            setSelectedInternalFilters={setSelectedInternalFilters}
          />
          <FilterName
            filter={Filter2 && Filter2}
            filterType="comparison"
            setFilter1Name={setFilter1}
            setFilter2Name={setFilter2}
            setSelectedInternalFilters={setSelectedInternalFilters}
          />
        </div>
      )}

      {results &&
        results.map((flag, i) => {
          return [...categories].indexOf(flag.CountryName) > -1 ? (
            <div className={`${styles.flagContainer}`} key={flag.CountryName}>
              {" "}
              <img src={flag.CountryFlag} />
              <h5>{flag.CountryName}</h5>
              <h6>{flag.CountryCount}</h6>
            </div>
          ) : null;
        })}
    </div>
  );
};

export default Flags;
